// 获取污染物浓度等级(num:数值;factor:因子名称,默认AQI;isDay:false为1小时,true为24小时或8小时)
var getAqiLevel = function(num, factor = 'AQI', isDay = false) {
	let level = 6
	factor = factor.toUpperCase()
	if (num === '0' || num === 0 || num) {
		num = Number(num)
		if (factor === 'AQI') {
			if (num >= 0 && num <= 50) {
				level = 0
			} else if (num > 50 && num <= 100) {
				level = 1
			} else if (num > 100 && num <= 150) {
				level = 2
			} else if (num > 150 && num <= 200) {
				level = 3
			} else if (num > 200 && num <= 300) {
				level = 4
			} else if (num > 300) {
				level = 5
			}
		}
		if (factor === 'SO2' || factor === 'SO₂') {
			if (isDay) {
				if (num >= 0 && num <= 50) {
					level = 0
				} else if (num > 50 && num <= 150) {
					level = 1
				} else if (num > 150 && num <= 475) {
					level = 2
				} else if (num > 475 && num <= 800) {
					level = 3
				} else if (num > 800 && num <= 1600) {
					level = 4
				} else if (num > 1600) {
					level = 5
				}
			} else {
				if (num >= 0 && num <= 150) {
					level = 0
				} else if (num > 150 && num <= 500) {
					level = 1
				} else if (num > 500 && num <= 650) {
					level = 2
				} else if (num > 650 && num <= 800) {
					level = 3
				} else if (num > 800) {
					level = 4
				}
			}
		}
		if (factor === 'NO2' || factor === 'NO₂') {
			if (isDay) {
				if (num >= 0 && num <= 40) {
					level = 0
				} else if (num > 40 && num <= 80) {
					level = 1
				} else if (num > 80 && num <= 180) {
					level = 2
				} else if (num > 180 && num <= 280) {
					level = 3
				} else if (num > 280 && num <= 565) {
					level = 4
				} else if (num > 565) {
					level = 5
				}
			} else {
				if (num >= 0 && num <= 100) {
					level = 0
				} else if (num > 100 && num <= 200) {
					level = 1
				} else if (num > 200 && num <= 700) {
					level = 2
				} else if (num > 700 && num <= 1200) {
					level = 3
				} else if (num > 1200 && num <= 2340) {
					level = 4
				} else if (num > 2340) {
					level = 5
				}
			}
		}
		if (factor === 'NO') {
			// NO无标准
			if (num >= 0) {
				level = 0
			}
		}
		if (factor === 'NOX') {
			// NOX标准同NO2
			if (isDay) {
				if (num >= 0 && num <= 40) {
					level = 0
				} else if (num > 40 && num <= 80) {
					level = 1
				} else if (num > 80 && num <= 180) {
					level = 2
				} else if (num > 180 && num <= 280) {
					level = 3
				} else if (num > 280 && num <= 565) {
					level = 4
				} else if (num > 565) {
					level = 5
				}
			} else {
				if (num >= 0 && num <= 100) {
					level = 0
				} else if (num > 100 && num <= 200) {
					level = 1
				} else if (num > 200 && num <= 700) {
					level = 2
				} else if (num > 700 && num <= 1200) {
					level = 3
				} else if (num > 1200 && num <= 2340) {
					level = 4
				} else if (num > 2340) {
					level = 5
				}
			}
		}
		if (factor === 'PM10' || factor === 'PM₁₀') {
			if (num >= 0 && num <= 50) {
				level = 0
			} else if (num > 50 && num <= 150) {
				level = 1
			} else if (num > 150 && num <= 250) {
				level = 2
			} else if (num > 250 && num <= 350) {
				level = 3
			} else if (num > 350 && num <= 420) {
				level = 4
			} else if (num > 420) {
				level = 5
			}
		}
		if (factor === 'CO') {
			if (isDay) {
				if (num >= 0 && num <= 2) {
					level = 0
				} else if (num > 2 && num <= 4) {
					level = 1
				} else if (num > 4 && num <= 14) {
					level = 2
				} else if (num > 14 && num <= 24) {
					level = 3
				} else if (num > 24 && num <= 36) {
					level = 4
				} else if (num > 36) {
					level = 5
				}
			} else {
				if (num >= 0 && num <= 5) {
					level = 0
				} else if (num > 5 && num <= 10) {
					level = 1
				} else if (num > 10 && num <= 35) {
					level = 2
				} else if (num > 35 && num <= 60) {
					level = 3
				} else if (num > 60 && num <= 90) {
					level = 4
				} else if (num > 90) {
					level = 5
				}
			}
		}
		if (factor === 'O3' || factor === 'O₃') {
			if (isDay) {
				if (num >= 0 && num <= 100) {
					level = 0
				} else if (num > 100 && num <= 160) {
					level = 1
				} else if (num > 160 && num <= 215) {
					level = 2
				} else if (num > 215 && num <= 265) {
					level = 3
				} else if (num > 265 && num <= 800) {
					level = 4
				} else if (num > 800) {
					level = 5
				}
			} else {
				if (num >= 0 && num <= 160) {
					level = 0
				} else if (num > 160 && num <= 200) {
					level = 1
				} else if (num > 200 && num <= 300) {
					level = 2
				} else if (num > 300 && num <= 400) {
					level = 3
				} else if (num > 400 && num <= 800) {
					level = 4
				} else if (num > 800) {
					level = 5
				}
			}
		}
		if (factor === 'PM25' || factor === 'PM₂.₅') {
			if (num >= 0 && num <= 35) {
				level = 0
			} else if (num > 35 && num <= 75) {
				level = 1
			} else if (num > 75 && num <= 115) {
				level = 2
			} else if (num > 115 && num <= 150) {
				level = 3
			} else if (num > 150 && num <= 250) {
				level = 4
			} else if (num > 250) {
				level = 5
			}
		}
		if (factor === 'WINDSPEED') {
			// 风
			if (num >= 0) {
				level = 7
			}
		}
		if (factor === 'VISIBILITY') {
			// 能见度
			if (num >= 0) {
				level = 7
			}
		}
	}
	return level
}

// 根据污染物浓度等级获取字体颜色(num:数值;factor:因子名称,默认AQI;isDay:false为1小时,true为24小时或8小时)
var getAqiFontColor = function(num, factor = 'AQI', isDay = false) {
	let color = '#fff'
	factor = factor.toUpperCase()
	if (num === '0' || num === 0 || num) {
		num = Number(num)
		if (num >= 0 && num <= 50) {
			color = '#323233'
		} else if (num > 50 && num <= 100) {
			color = '#323233'
		} else if (num > 100) {
			color = '#fff'
		}
		if (factor === 'SO2' || factor === 'SO₂') {
			if (isDay) {
				if (num >= 0 && num <= 50) {
					color = '#323233'
				} else if (num > 50 && num <= 150) {
					color = '#323233'
				} else if (num > 150) {
					color = '#fff'
				}
			} else {
				if (num >= 0 && num <= 150) {
					color = '#323233'
				} else if (num > 150 && num <= 500) {
					color = '#323233'
				} else if (num > 500) {
					color = '#fff'
				}
			}
		}
		if (factor === 'NO2' || factor === 'NO₂') {
			if (isDay) {
				if (num >= 0 && num <= 40) {
					color = '#323233'
				} else if (num > 40 && num <= 80) {
					color = '#323233'
				} else if (num > 80) {
					color = '#fff'
				}
			} else {
				if (num >= 0 && num <= 100) {
					color = '#323233'
				} else if (num > 100 && num <= 200) {
					color = '#323233'
				} else if (num > 200) {
					color = '#fff'
				}
			}
		}
		if (factor === 'NO') {
			// NO无标准
			if (num >= 0) {
				color = '#323233'
			}
		}
		if (factor === 'NOX') {
			// NOX标准同NO2
			if (isDay) {
				if (num >= 0 && num <= 40) {
					color = '#323233'
				} else if (num > 40 && num <= 80) {
					color = '#323233'
				} else if (num > 80) {
					color = '#fff'
				}
			} else {
				if (num >= 0 && num <= 100) {
					color = '#323233'
				} else if (num > 100 && num <= 200) {
					color = '#323233'
				} else if (num > 200) {
					color = '#fff'
				}
			}
		}
		if (factor === 'PM10' || factor === 'PM₁₀') {
			if (num >= 0 && num <= 50) {
				color = '#323233'
			} else if (num > 50 && num <= 150) {
				color = '#323233'
			} else if (num > 150) {
				color = '#fff'
			}
		}
		if (factor === 'CO') {
			if (isDay) {
				if (num >= 0 && num <= 2) {
					color = '#323233'
				} else if (num > 2 && num <= 4) {
					color = '#323233'
				} else if (num > 4) {
					color = '#fff'
				}
			} else {
				if (num >= 0 && num <= 5) {
					color = '#323233'
				} else if (num > 5 && num <= 10) {
					color = '#323233'
				} else if (num > 10) {
					color = '#fff'
				}
			}
		}
		if (factor === 'O3' || factor === 'O₃') {
			if (isDay) {
				if (num >= 0 && num <= 100) {
					color = '#323233'
				} else if (num > 100 && num <= 160) {
					color = '#323233'
				} else if (num > 160) {
					color = '#fff'
				}
			} else {
				if (num >= 0 && num <= 160) {
					color = '#323233'
				} else if (num > 160 && num <= 200) {
					color = '#323233'
				} else if (num > 200) {
					color = '#fff'
				}
			}
		}
		if (factor === 'PM25' || factor === 'PM₂.₅') {
			if (num >= 0 && num <= 35) {
				color = '#323233'
			} else if (num > 35 && num <= 75) {
				color = '#323233'
			} else if (num > 75) {
				color = '#fff'
			}
		}
		if (factor === 'WINDSPEED') {
			// 风
			if (num >= 0) {
				color = '#fff'
			}
		}
		if (factor === 'VISIBILITY') {
			// 能见度
			if (num >= 0) {
				color = '#fff'
			}
		}
	}
	return color
}

export { getAqiLevel, getAqiFontColor }
